module.exports = {
      id: "glyph:envelope-usage",
      viewBox: "0 0 19 15",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#glyph:envelope-usage",
      toString: function () {
        return this.url;
      }
    }